// Thin wrapper around `GET /api/people/org-graph` (PRODOPSAI-491): the
// all-users org-graph endpoint, authenticate-only. Used by both the all-users
// People page and the admin People page (admins are authenticated, so the
// shared endpoint serves both). The `api` helper already adds the `/api`
// prefix (see CLAUDE.md frontend rule), so we pass the endpoint without it.
import { api } from '@/lib/api';
import type { IApiResponse, IOrgGraphResponse } from '@skystone/shared';

export const orgGraphApi = {
  get: async (): Promise<IOrgGraphResponse> => {
    const result = await api.get<IApiResponse<IOrgGraphResponse>>('/people/org-graph');
    return result.data;
  },
};
